import { Fragment } from 'react/jsx-runtime'
import { useVersionCheck } from '@/hooks/useCheckAppVersion'
import { Dialog } from '@mui/material'
import { useAuthContext } from '@/features/auth/context'
import ChangelogPopup from '@/components/common/ChangelogPopup/ChangelogPopup'
import ConfirmModalUI from '@/components/common/ConfirmModalUI/ConfirmModalUI'

const VersionCheck = () => {
  const { isLogin } = useAuthContext()

  const { shouldReload, handleReload, handleSnooze } = useVersionCheck(30000)

  const onCloseConfirm = () => {
    handleReload()
  }

  const onClose = () => {
    handleSnooze()
  }

  if (!isLogin) return null

  return (
    <Fragment>
      <Dialog open={shouldReload} onClose={onCloseConfirm}>
        <ConfirmModalUI
          title="New Version Available"
          text="A newer version of this app is available. To get the latest updates and improvements, please reload the page."
          confirmText="Reload"
          cancelText="Later"
          onConfirm={onCloseConfirm}
          onClose={onClose}
        />
      </Dialog>
      {/* Changelog waits until the reload prompt is gone. */}
      <ChangelogPopup blocked={shouldReload} />
    </Fragment>
  )
}

export default VersionCheck
